import { defineStore } from "pinia";
import { ref } from "vue";
import { getPublicNavMenus } from "@/api/navMenu";

const FALLBACK_MENUS = [
  { menuCode: "space_3d", menuName: "3D空间", routePath: "/", sortOrder: 1 },
  {
    menuCode: "ip_mall",
    menuName: "IP商城",
    routePath: "/shopping",
    sortOrder: 2,
  },
  {
    menuCode: "game_center",
    menuName: "游戏中心",
    routePath: "/_game",
    sortOrder: 3,
  },
  {
    menuCode: "trade_center",
    menuName: "交易中心",
    routePath: "/buy",
    sortOrder: 4,
  },
];

export const useNavMenuStore = defineStore("navMenu", () => {
  const menus = ref([]);
  const loaded = ref(false);

  const fetchMenus = async () => {
    try {
      const res = await getPublicNavMenus();
      if (res.code === 200 && Array.isArray(res.data)) {
        menus.value = res.data;
      } else {
        menus.value = [...FALLBACK_MENUS];
      }
    } catch {
      menus.value = [...FALLBACK_MENUS];
    } finally {
      loaded.value = true;
    }
  };

  return {
    menus,
    loaded,
    fetchMenus,
  };
});
